import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { CONTRACTS } from '../apiUrls';

const mutationAddVadContract = (onSuccess, onError) => {
    return {
        mutationFn: ({ contractsAccessId, contractLabel, application, bankCode, merchantId, x25Address, logicalNumber }) => {
            return client.post(replaceParameters(CONTRACTS.ADD_VAD_CONTRACT.url, { contractAccessId: contractsAccessId }), {
                contractLabel, application, bankCode, merchantId, x25Address, logicalNumber
            });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationAddVadContract;